export enum AttentionRequiredExceptions {
    generalException = 'General Exception',
    insufficientPermission = 'Insufficient Permission',
    invalidCredentials = 'Invalid Credentials',
    noCredentialsDB = 'No Credentials'
}
